<template>
  <div class="hard">
    <div :height="bannerHeight+'px'">
      <img
      ref="bannerHeight"
      @load="imgLoad"
      style="display: block;width: 100%;height: 100%;"
      :src="banner"
      alt=""
      />
    </div>
    <div class="wrapper">
      <p class="waretitle">智能软件</p>
      <div v-for="(item, index) in category" :key="index">
        <el-row class="el" v-if="index % 2 == 0">
          <el-col :span="13">
            <img :src="item.img" alt="" />
          </el-col>
          <el-col :span="11">
            <p>
              <span class="title">{{ item.name }}</span>
              <span class="desc">
                {{ item.desc }}
              </span>
              <span class="btn" @click="goMore(item.id)">查看详情</span>
            </p>
          </el-col>
        </el-row>
        <el-row class="el" v-else>
          <el-col :span="11">
            <p>
              <span class="title">{{ item.name }}</span>
              <span class="desc">
                {{ item.desc }}
              </span>
              <span class="btn" @click="goMore(item.id)">查看详情</span>
            </p>
          </el-col>
          <el-col :span="13">
            <img :src="item.img" alt="" width="100%" height="250px" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapMutations } from "vuex";
import { baseUrl } from "../api/index";

export default {
  data() {
    return {
      category: [],
      banner: "",
      bannerHeight: "",
    };
  },
  created() {
    this.getCategoryInfo({ mid: 3 });
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    ...mapMutations("solution", ["setImg", "setName", "setDesc"]),
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    goMore(id) {
      this.category.forEach((ele) => {
        if (ele.id == id) {
          this.setImg(ele.banner);
          this.setName(ele.name);
          this.setDesc(ele.desc);
        }
      });
      this.$router.push("/waremoresoft/" + id);
    },
    async getCategoryInfo(params) {
      let res = await this.$api.getCategoryInfo(params);
      this.category = res.data.data.category_info;
      this.category.forEach((ele) => {
        ele.img = baseUrl + ele.img;
        ele.banner = baseUrl + ele.banner;
      });
      this.banner = baseUrl + res.data.data.menu_info.banner;
    },
  },
};
</script>
  
  <style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .hard {
    width: 100%;
    .waretitle {
      position: relative;
      color: #333;
      font-weight: bold;
      font-size: 0.36rem;
      margin-top: 0.5rem;
      text-align: center;
      &::after {
        position: absolute;
        top: 0.56rem;
        left: 6rem;
        margin-left: -0.3rem;
        content: "";
        display: inline-block;
        height: 0.08rem;
        width: 0.6rem;
        border-radius: 0.05rem;
        background: linear-gradient(90deg, #3f66f5, #009fff);
      }
    }
   
    .wrapper {
      width: 12rem;
      margin: 0 auto;
      .el-col-13 {
        height: 4rem;
      }
      .el {
        margin-top: 0.8rem;
        margin-bottom: 0.5rem;
        border-radius: 0.1rem;
        overflow: hidden;
        box-shadow: 0 2px 20px rgba(150, 150, 150, 0.3);
        transition: all 600ms;
        &:hover {
          box-shadow: 0px 2px 25px rgba(150, 150, 150, 0.5);
          transform: translateY(-7px);
        }
        p {
          position: relative;
          padding: 0.5rem 0.3rem 0 0.3rem;
          font-size: 0.15rem;
          line-height: 0.26rem;
          background-color: #fff;
          height: 4rem;
          box-sizing: border-box;
          color: #666;
          .desc{ 
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 7;
          }
          .title {
            display: block;
            font-size: 0.22rem;
            color: #388fff;
            padding-bottom: 0.2rem;
          }
          .btn {
            display: inline-block;
            position: absolute;
            bottom: 0.5rem;
            right: 2.3rem;
            width: 1.3rem;
            height: 0.4rem;
            // border: 1px solid #2B7CD9;
            border: 1px solid #388fff;
            border-radius: 0.2rem;
            font-size: 0.18rem;
            background-color: #fff;
            line-height: 0.4rem;
            text-align: center;
            &:hover {
              background-color: #388fff;
              cursor: pointer;
              color: #fff;
            }
          }
        }

        img {
          width: 100%;
          height: 4rem;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .hard {
    min-height: 5rem;
    width: 100%;
    img {
    //   width: 100%;
    //   height: 1.5rem;
      margin-bottom: 0.1rem;
    }

    .wrapper {
      width: 3.2rem;
      margin: 0 auto;
      .waretitle {
        position: relative;
        color: #333;
        font-weight: bold;
        font-size: 0.12rem;
        // margin-top: 0.25rem;
        text-align: center;
        &::after {
          position: absolute;
          top: 0.2rem;
          left: 1.75rem;
          margin-left: -0.29rem;
          content: "";
          display: inline-block;
          height: 0.04rem;
          width: 0.3rem;
          border-radius: 0.025rem;
          background: linear-gradient(90deg, #3f66f5, #009fff);
        }
      }
      .el-col-13 {
        height: 1.5rem;
      }
      .el {
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
        border-radius: 0.1rem;
        overflow: hidden;
        box-shadow: 0 2px 20px rgba(150, 150, 150, 0.3);
        transition: all 600ms;
        &:hover {
          box-shadow: 0px 2px 25px rgba(150, 150, 150, 0.5);
          transform: translateY(-7px);
        }
        p {
          position: relative;
          padding: 0.15rem 0.1rem 0 0.1rem;
          font-size: 0.08rem;
          background-color: #fff;
          height: 1.5rem;
          box-sizing: border-box;
          color: #666;
          .title {
            display: block;
            font-size: 0.12rem;
            color: #388fff;
            padding-bottom: 0.05rem;
          }
          .desc{
            display: inline-block;
            width: 1.26rem;
            overflow: hidden; /*文本超出隐藏*/
            display:-webkit-box; /*盒子模型微弹性伸缩模型*/
            -webkit-box-orient: vertical;/*伸缩盒子的子元素垂直排列*/
            -webkit-line-clamp: 5; /*文本显示3行*/
            word-break: break-all;
            line-height: 0.11rem;
          }
          .btn {
            display: inline-block;
            position: absolute;
            bottom: 0.2rem;
            right: 0.5rem;
            width: 0.6rem;
            height: 0.15rem;
            border: 1px solid #388fff;
            border-radius: 0.15rem;
            // font-size: 0.18rem;
            background-color: #fff;
            line-height: 0.15rem;
            text-align: center;
            &:hover {
              background-color: #388fff;
              cursor: pointer;
              color: #fff;
            }
          }
        }

        img {
          width: 100%;
          height: 1.5rem;
        }
      }
    }
  }
}
</style>